import io from 'socket.io-client';
import { api_server } from './../config.json';



let socket = io(api_server);

export default socket;





